import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

function Content({ children, backgroundColor = "bg-dupontCream" }) {
  const containerRef = useRef(null);
  const { pathname } = useLocation();

  // Whenever the user goes to a new page, start it at the top. (It ran only
  // once before, so a new page opened wherever the last one had been scrolled
  // to.) Only the page, not ?tab= changes within it.
  useEffect(() => {
    if (containerRef && containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  }, [pathname]);

  return (
    <div
      ref={containerRef}
      className={`overflow-auto flex-1 pt-[56px] md:pt-0 ${backgroundColor} dark:bg-darkPrimary scrollbar scrollbar-thumb-rounded scrollbar-thumb-dupontGold scrollbar-track-transparent transition-colors duration-200`}
    >
      {children}
    </div>
  );
}

Content.propTypes = {
  children: PropTypes.node,
  backgroundColor: PropTypes.string,
};

export default Content;
